var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3232_25485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2294 24.5L28.6814 19.748H30.0212L31.4732 24.5H30.5492L29.2556 20.309H29.4272L28.1534 24.5H27.2294ZM28.1006 23.51V22.6718H30.6086V23.51H28.1006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_25485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6 28.9191C31.6 27.7628 29.9294 27.166 29.3656 26.0936L29.3448 26.075L29.3343 26.0936C28.7705 27.166 27.1 27.7628 27.1 28.9191C27.1 29.8889 28.5304 30.2619 29.2299 29.4506C29.2403 29.4133 29.2299 29.7117 29.1777 29.8796C29.0106 30.3738 28.4051 31.1012 28.1127 31.325C28.5199 31.0172 30.1591 31.0172 30.5663 31.325C30.274 31.1012 29.6997 30.4018 29.5014 29.8796C29.4596 29.7304 29.4387 29.5905 29.4283 29.4413C30.1174 30.3178 31.6 29.9075 31.6 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.3999 35.4944C39.3999 33.4131 36.393 32.3389 35.3781 30.4086L35.3405 30.375L35.3217 30.4086C34.3069 32.3389 31.2999 33.4131 31.2999 35.4944C31.2999 37.2401 33.8746 37.9115 35.1338 36.4512C35.1526 36.3841 35.1338 36.9212 35.0398 37.2233C34.7391 38.1129 33.6491 39.4222 33.1229 39.825C33.8558 39.2711 36.8064 39.2711 37.5394 39.825C37.0132 39.4222 35.9795 38.1633 35.6224 37.2233C35.5473 36.9548 35.5097 36.703 35.4909 36.4344C36.7312 38.0122 39.3999 37.2737 39.3999 35.4944Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3232_25485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.25,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2294 24.5L49.6814 19.748H51.0212L52.4732 24.5H51.5492L50.2556 20.309H50.4272L49.1534 24.5H48.2294ZM49.1006 23.51V22.6718H51.6086V23.51H49.1006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3232_25485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3499 27.2009C49.6102 25.914 47.725 26.4176 47.725 27.6822C47.725 29.1034 49.6818 29.607 50.338 30.9276L50.3499 30.95L50.3619 30.9276C51.0181 29.607 52.9749 29.1034 52.9749 27.6822C52.9869 26.4176 51.0897 25.914 50.3499 27.2009Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3232_25485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3499 32.4018C55.0184 30.0853 51.625 30.9918 51.625 33.268C51.625 35.8263 55.1472 36.7328 56.3285 39.1098L56.3499 39.15L56.3714 39.1098C57.5527 36.7328 61.0749 35.8263 61.0749 33.268C61.0964 30.9918 57.6815 30.0853 56.3499 32.4018Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3232_25485",
    x: 10.25,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3232_25485",
    x: 31.25,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_25485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(26.35 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3232_25485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(47.35 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3232_25485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8,
    height: 10.8,
    fill: "white",
    transform: "translate(50.95 29.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldemActive);
export default __webpack_public_path__ + "static/media/holdem-active.2c98f0b6a3f17fe40ae982549e7742e4.svg";
export { ForwardRef as ReactComponent };